import * as yup from 'yup';

const ipV4Regex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;

yup.addMethod(yup.string, 'ipV4', function () {
  return this.test('ipV4', function (value) {
    const { path, createError } = this;
    return new Promise((resolve, reject) => {
      if (ipV4Regex.test(value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid ip address' }));
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  department: yup.string().required(),
  supervisorDevice: yup
    .number()
    .required()
    .positive()
    .integer(),
  manufacturer: yup.string().required(),
  model: yup.string().required(),
  ip: yup
    .string()
    .required()
    .ipV4(),
  port: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535),
  extensions: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535),
  groups: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535),
  ogms: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535),
  networks: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535),
  localCode: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(1000)
});

export default schema;
